import React from 'react';

export default () => <p className='errorText'>Please answer the question!</p>